/*
Actions:
anything that can happen in our application
when a user click a button , when data finnishes loadding or starts loading....
any action that could potentially change the state 
of our entire application
*/
export const counterButtonClicked = {
    type: 'COUNTER_BUTTON_CLICKED',
    payload: { amount: 1 },
}
export const localTimeButtonClicked = (localtime) => {
    return {
        type: 'CHANGE_TIMEZONE',
        payload: { localtime },
    }
}
export const selectorDayChange = (day) => {
    return {
        type: 'CHANGE_DAY',
        payload: { day },
    }
}

export const selectorEventChange = (event) => {
    return {
        type: 'CHANGE_EVENT',
        payload: { event },
    }
}

export const selectorphaseChange = (phase) => {
    return {
        type: 'CHANGE_PHASE',
        payload: { phase },
    }
}

export const componentPhaseSelectorChange = (phase) => {
    return {
        type: 'COMPONENT_PHASESELECTOR_CHANGE_PHASE',
        payload: { phase },
    }
}

export const componentPhaseSelectorChangeExpanded = (expanded) => {
    return {
        type: 'COMPONENT_PHASESELECTOR_CHANGE_EXPANDED',
        payload: { expanded },
    }
}

export const componentIntermediateSelector = (intermediateSelector) => {
    return {
        type: 'COMPONENT_INTERMEDIATESELECTOR_CHANGE',
        payload: { intermediateSelector },
    }
}

export const addLegend = (legend) => {
    return {
        type: 'ADD_LEGEND',
        payload: { legend },
    }
}

export const removeAllLegends = {
    type: 'REMOVE_ALL_LEGENDS'
}

export const changeIdLegends = (legendsId) => {
    return {
        type: 'CHANGE_ID_LEGENDS',
        payload: { legendsId }
    }
}


export const changeCompetition = (competition) => {
    return {
        type: 'CHANGE_COMPETITION',
        payload: { competition }
    }
}

export const changeRsc = (rsc) => {
    return {
        type: 'CHANGE_RSC',
        payload: { rsc }
    }
}

export const changeLocale = (locale) => {
    return {
        type: 'CHANGE_LOCALE',
        payload: { locale }
    }
}